import { render, staticRenderFns } from "./HoeyInfo.vue?vue&type=template&id=8c849ff0&scoped=true"
import script from "./HoeyInfo.vue?vue&type=script&lang=js"
export * from "./HoeyInfo.vue?vue&type=script&lang=js"
import style0 from "./HoeyInfo.vue?vue&type=style&index=0&id=8c849ff0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c849ff0",
  null
  
)

export default component.exports